// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".customerDiv{min-width:120px;height:260px;border:1px solid #ebeef5;box-shadow:0 2px 12px 0 rgba(0,0,0,.1);background-color:#fff;position:fixed;top:0;left:0;overflow:auto;z-index:999}.itemCustomer{height:25px;line-height:25px;padding:5px 10px;border:1px solid #ebeef5;color:#606266;font-size:10px;overflow:hidden}.itemCustomer:hover{background-color:#ebeef5}", ""]);
// Exports
module.exports = exports;
